/* Dutch (Netherlands) */

export default {
  "Selected": "Geselecteerd",
  "Clear": "Wissen",
  "Search": "Zoeken",
  "No results found": "Geen resultaten gevonden",
  "Date-range": "Datumbereik",
  "Date": "Datum",
  "Add Another": "Nog een toevoegen",
  "Select up to": "Selecteer maximaal",
  "days": "dagen",
  "Recent": "Recent",
  "Search Entities": "Entiteiten zoeken",
  "Try searching for an entity's name, or ID. You can also search for a location.": "Zoek op naam of ID van een entiteit. U kunt ook zoeken op locatie.",
  "Your recent search history will be shown here the next time you use search.": "Uw recente zoekgeschiedenis wordt hier weergegeven wanneer u opnieuw zoekt.",
  "l": "l",
  "gal": "gal",
  "L/100KM": "L/100KM",
  "MPG": "MPG",
  "KM/L": "KM/L",
  "kph": "km/u",
  "mph": "mph",
  "kph/s": "km/u/s",
  "mph/s": "mph/s",
  "m": "m",
  "ft": "ft",
  "kg": "kg",
  "lbs": "lbs",
  "°C": "°C",
  "°F": "°F",
  "square meters": "vierkante meter",
  "square feet": "vierkante voet",
  "square kilometers": "vierkante kilometer",
  "square miles": "vierkante mijl",
  "kPa": "kPa",
  "psi": "psi",
  "tonne": "ton",
  "ton": "ton",
  "km": "km",
  "mi": "mi",
  "just now": "zojuist",
  "now": "nu",
  "ago": "geleden",
  "yesterday at": "gisteren om",
  "weeks": "weken",
  "hours": "uur",
  "minutes": "minuten",
  "seconds": "seconden",
  "week": "week",
  "day": "dag",
  "hour": "uur",
  "minute": "minuut",
  "second": "seconde",
  "wk": "wk",
  "hr": "u",
  "min": "min",
  "sec": "sec",
  "Enter at least 2 characters to search": "Voer ten minste 2 tekens in om te zoeken",
  "Keyword": "Zoekwoord",
  "Show by type": "Tonen op type",
  "Find": "Zoeken",
  "by": "door",
  "Try searching for": "Probeer te zoeken naar",
  "Try searching by keyword.": "Probeer te zoeken op zoekwoord.",
  "No matches found": "Geen overeenkomsten gevonden",
  "Enter atleast two characters to search": "Voer ten minste twee tekens in om te zoeken",
  "Group results": "Resultaten groeperen",
  "Filter for": "Filteren op",
  "More": "Meer",
  "more": "meer",
  "Drag and drop images & documents": "Sleep afbeeldingen en documenten hierheen",
  "Upload": "Uploaden",
  "Upload failed": "Upload mislukt",
  "Uploads failed": "Uploads mislukt",
  "Uploaded files have the following issues:": "Geüploade bestanden hebben de volgende problemen:",
  "File exceeds": "Bestand overschrijdt",
  "limit": "limiet",
  "is not supported. Please upload": "wordt niet ondersteund. Upload",
  "File is empty or corrupted.": "Bestand is leeg of beschadigd.",
  "Network error": "Netwerkfout",
  "Invalid format or size.": "Ongeldig formaat of grootte.",
  "Supported formats:": "Ondersteunde formaten:",
  "File Size:": "Bestandsgrootte:",
  "MB Max": "MB max.",
  "of": "van",
  "uploaded": "geüpload",
  "file": "bestand",
  "files": "bestanden",
  "out of": "van",
  "Retry": "Opnieuw proberen",
  "Fetch Failed": "Ophalen mislukt",
  "B": "B",
  "KB": "KB",
  "MB": "MB",
  "GB": "GB",
  "Please upload a document": "Upload een document",
  "An error occurred with this file.": "Er is een fout opgetreden bij dit bestand.",
  "Item": "Item",
  "image": "afbeelding",
  "You can only upload up to": "U kunt maximaal uploaden",
  "and": "en",
  "or": "of",
  "Unknown format": "Onbekend formaat",
  "Please enter numeric values": "Voer numerieke waarden in",
  "Date format": "Datumformaat",
  "Please select a date after": "Selecteer een datum na",
  "Please select a date before": "Selecteer een datum voor",
  "Please select a date between": "Selecteer een datum tussen",
  "Please select a valid date": "Selecteer een geldige datum",
  "Please enter a valid date": "Voer een geldige datum in",
  "Write something...": "Schrijf iets...",
  "Esc to": "Esc om te",
  "Cancel": "Annuleren",
  "Enter": "Enter",
  "to": "om te",
  "Save": "Opslaan",
  "Show Filters": "Filters tonen",
  "Hide Filters": "Filters verbergen",
  "Show deactivated entities": "Gedeactiveerde entiteiten weergeven",
  "Show deactivated": "Gedeactiveerde weergeven",
  "Deactivated": "Gedeactiveerd",
  "No data available": "Geen gegevens beschikbaar",
  "Image not available": "Afbeelding niet beschikbaar",
  "Video not available": "Video niet beschikbaar",
  "Customize Columns": "Kolommen aanpassen",
  "Drag to reorder. Toggle visibility with the eye icon.": "Sleep om opnieuw te ordenen. Schakel zichtbaarheid in met het oogicoon.",
  "Apply": "Toepassen",
  "results": "resultaten",
  "Table pagination": "Tabelpaginering",
  "Previous page": "Vorige pagina",
  "Next page": "Volgende pagina",
  "Press < for quick navigation": "Druk op < voor snelle navigatie",
  "Press > for quick navigation": "Druk op > voor snelle navigatie",
  "Last updated:": "Laatst bijgewerkt:",
};
